import { SuccessIcon } from "components/ui/icons/iaAgent/SuccessIcon"
import style from "./SuccessChatAnswer.module.scss"

const { bubble } = style

type Props = { text: string }

export const SuccessChatAnswer = ({ text }: Props) => {
	return (
		<div className={bubble}>
			<SuccessIcon />
			{text}
		</div>
	)
}
